export interface CacheCollectionOptions<T> {
  key: string;
  data: T;
  expireInMins?: number;
  collectionKey?: string;
}

export interface CacheRecord {
  value: string;
  expiration: number;
  appVersion: string;
}

export interface CacheRecordMap {
  [key: string]: CacheRecord;
}

export interface CacheCollection {
  collectionKey: string;
  collectionRecordMap: CacheRecordMap;
}
